import cx from "clsx";
import styles from "./PolicyTiles.module.scss";
import { IdCardTile } from "./IdCardTile";
import { ClaimsTile } from "./ClaimsTile";
import { BillingTile } from "./BillingTile";
import { DocumentsTile } from "./DocumentsTile";
import { PolicyDetails } from "shared";

type PolicyProps = {
  policy: PolicyDetails;
  className?: string;
};

export const PolicyTiles = ({ policy, className }: PolicyProps) => {
  return (
    <div className={cx(styles.policyTiles, className)}>
      <IdCardTile policy={policy} />
      <ClaimsTile policy={policy} />
      <BillingTile />
      <DocumentsTile policy={policy} />
    </div>
  );
};
